import React, { Component, Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Collapse from '@material-ui/core/Collapse'

const styles = theme => ({
  messageBox: {
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: '#000000',
    '& p': {
      marginTop: 0,
      marginBottom: 16,
    },
    '& span': {
      display: 'block',
    },
  },
  messageTitle: {
    fontWeight: 'bold',
    color: '#ff4e44',
    marginBottom: 16,
  },
  cardDeleted: {
    color: '#ff4e44',
    marginBottom: 16,
  },
})

class PaymentMessage extends Component {
  state = {
    user: window.state.user,
    lastPayment: window.state.lastPayment,
    licenseExpired: window.state.licenseExpired,
  }

  render() {
    const { classes, statusAutoPay, card, user } = this.props
    const { type, expirationDate, status } = this.props.license
    const { lastPayment, licenseExpired } = this.state

    const autoPayOff =
      card && !card.autoPay ? (
        <Collapse in={!statusAutoPay}>
          <div className={classes.messageBox}>
            <header className={classes.messageTitle}>
              Вы отключили автоплатеж.
            </header>
            <p>Без своевременной оплаты доступ к сервису будет отключен.</p>
            <p>
              <span>
                <strong>Оплаченный период:</strong>
              </span>{' '}
              <span>{expirationDate}</span>
            </p>
            <p>
              Если вам нужна помощь в решении ситуации – напишите нам в чат,
              поможем.
            </p>
          </div>
        </Collapse>
      ) : null

    const cardOff = !card && (
      <div className={classes.messageBox}>
        <header className={classes.messageTitle}>Вы отвязали карту.</header>
        <p>Без своевременной оплаты доступ к сервису будет отключен.</p>
        <p>
          <span>
            <strong>Оплаченный период:</strong>
          </span>{' '}
          <span>{expirationDate}</span>
        </p>
        <p>
          Если вам нужна помощь в решении ситуации – напишите нам в чат,
          поможем.
        </p>
      </div>
    )

    const trialPeriodOver =
      status === 'EXPIRED' ? (
        <div className={classes.messageBox}>
          <header className={classes.messageTitle}>
            {type === 'TRIAL'
              ? `Бесплатный период закончился.`
              : `Лицензия не активна.`}
          </header>
          {user.has_deleted_card && !card
            ? (
              <p className={classes.cardDeleted}>Предыдущая привязанная карта была автоматически отвязана после 7ми неудачных попыток списания оплаты.</p>
            )
            : null}
          <p>
            Чтобы продолжить использовать ROMI center
            {card && !statusAutoPay ? (
              <strong>, включите автоплатеж.</strong>
            ) : null}
            {!card ? <strong>, добавьте карту.</strong> : null}
            {lastPayment && !lastPayment.status && card ? (
              <strong>, ошибка платежа.</strong>
            ) : null}
            {card && statusAutoPay && lastPayment && lastPayment.status ? (
              <strong>, сделайте платеж.</strong>
            ) : null}
          </p>
        </div>
      ) : null

    const paymentError = lastPayment && !lastPayment.status && card && (
      <div className={classes.messageBox}>
        <header className={classes.messageTitle}>
          С привязанной картой что-то не так.
        </header>
        <p>Без своевременной оплаты доступ к сервису будет отключен.</p>
        <p>
          Проверьте наличие средств на счету привязанной карты. Пополните счет
          на необходимую сумму, или измените карту для оплаты.
        </p>
        <p>
          Если вам нужна помощь в решении ситуации – напишите нам в чат,
          поможем.
        </p>
      </div>
    )

    let message

    if (licenseExpired) {
      message = trialPeriodOver
    } else {
      message = (
        <Fragment>
          {autoPayOff}
          {cardOff}
          {paymentError}
        </Fragment>
      )
    }

    return message
  }
}

export default withStyles(styles)(PaymentMessage)
